"use strict";

if ($("#rightColumn").length > 0) {
  $(window).resize(function(){
    var w = window.innerWidth;
    if (w < 992) {
      if ($("#leftColumn").children().length && $("#rightColumn").children().length == 0) {return false;}
      var detach = $("#rightColumn .sidebar-content").detach();
      $("#leftColumn").append(detach);
    }
    else {
      if ($("#rightColumn").children().length > 1) {return false;}
      var detach = $("#leftColumn .sidebar-content").detach();
      $("#rightColumn").append(detach);
    }
  });
  $(window).trigger('resize');
}

if ($(".image-links-prototypes").length) {
  $(".image-links-prototypes").each(function(){$(this).parent().addClass("image-links-prototypes");});
}

function changeInputNameCartPage() {
  var name= "updates[]";
  if ($(window).width() > 767) {
    $(".input-mobile").attr("name", "");
    $(".input-desktop").attr("name", name);
  }
  else {
    $(".input-mobile").attr("name", name);
    $(".input-desktop").attr("name", "");
  }
}

if ($(".input-mobile").length && $(".input-desktop").length ) {
  changeInputNameCartPage();
  $(window).resize(changeInputNameCartPage);
}

function debouncer(func, timeout) {
    var timeoutID, timeout = timeout || 500;
    return function() {
        var scope = this,
            args = arguments;
        clearTimeout(timeoutID);
        timeoutID = setTimeout(function() {
            func.apply(scope, Array.prototype.slice.call(args));
        }, timeout);
    }
}

// Slide Column
function slideColumn(){
  if ($('#leftColumn').length > 0) {
    $(window).resize(function(){
      if(window.innerWidth < 992 ) {
        filtersHeight();
      } else {
        $('#leftColumn').removeAttr('style');
      }
    });
    
    $('.slide-column-close').addClass('position-fix');
    $('.slide-column-open').on('click', function(e){
      e.preventDefault();
      $('#leftColumn').addClass('column-open');
      $('body').css("top", -$('body').scrollTop());
      $('body').addClass("no-scroll").append( '<div class="modal-filter"></div>');	
      if ($(".modal-filter").length > 0) {	        	
          $(".modal-filter").click(function(){
           $('.slide-column-close').trigger('click');
          })
        } 
    });
    $('.slide-column-close').on('click', function(e){
      e.preventDefault();
      $("#leftColumn").removeClass('column-open');
      $(".modal-filter").unbind();
      $(".modal-filter").remove();
      var top = parseInt($('body').css("top").replace("px", ""))*-1;
      $('body').removeAttr("style");
      $('body').removeClass("no-scroll");
      $('body').scrollTop(top);
    });
  } 
}
function filtersHeight(){
  var $obj = $('#leftColumn');
  var w_height = window.innerHeight;
  var o_height = $obj.outerHeight();
  var delta = parseInt(w_height - o_height);
  if(delta < 0) {
    $obj.css({"max-height": o_height + delta, "overflow": "auto", "overflow-x": "hidden" });
  }
}

// Home Page Carousel
if ($('#homeCarousel').length > 0) {
  $('#homeCarousel').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 9000,
    fade: true,
    speed: 800,
  });
  $('#homeCarousel').on('lazyLoaded', function (e, slick, image, imageSource) {
    image.parent().css('background-image', 'url("' + imageSource + '")');
    image.hide();
  });
}

// Home page carousel test
if ($('#homeCarousel2').length > 0) {
  $('#homeCarousel2').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 9000,
    fade: true,
    speed: 800,
  });
  $('#homeCarousel2').on('lazyLoaded', function (e, slick, image, imageSource) {
    image.parent().css('background-image', 'url("' + imageSource + '")');
    image.hide();
  });
}

// Product Carousel
function productCarousel(carousel,numberXl,numberLg,numberMd,numberSm,numberXs) {

    var windowW = window.innerWidth || $(window).width();

    var slidesToShowXl = (numberXl > 0) ? numberXl : 6;
    var slidesToShowLg = (numberLg > 0) ? numberLg : 4;
    var slidesToShowMd = (numberMd > 0) ? numberMd : numberLg;
    var slidesToShowSm = (numberSm > 0) ? numberSm : numberMd;
    var slidesToShowXs = (numberXs > 0) ? numberXs : 1;
    
    var carousel = carousel;
    var speed = 500;
        
    if (carousel.parent().find('.carousel-products__button').length > 0) {

            carousel.slick({
                    prevArrow: carousel.parent().find('.carousel-products__button .btn-prev'),
                    nextArrow: carousel.parent().find('.carousel-products__button .btn-next'),
                    dots: true,
                    slidesToShow: slidesToShowXl,
                    slidesToScroll: slidesToShowXl,
                    responsive: [{
                        breakpoint: 1770,
                        settings: {
                            slidesToShow: slidesToShowLg,
                            slidesToScroll: slidesToShowLg
                        }
                    },{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: slidesToShowMd,
                            slidesToScroll: slidesToShowMd
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: slidesToShowSm,
                            slidesToScroll: slidesToShowXs
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: slidesToShowXs,
                            slidesToScroll: slidesToShowXs
                        }
                    }]
                });
        }
        else {
            carousel.slick({
                slidesToShow: slidesToShowXl,
                slidesToScroll: 1,
                speed: speed,
                    responsive: [{
                        breakpoint: 1770,
                        settings: {
                            slidesToShow: slidesToShowLg,
                            slidesToScroll: slidesToShowLg
                        }
                    },{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: slidesToShowMd,
                            slidesToScroll: slidesToShowMd
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: slidesToShowSm,
                            slidesToScroll: slidesToShowXs
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: slidesToShowXs,
                            slidesToScroll: slidesToShowXs
                        }
                    }]
            });
        }
    

    fixCarouselHover(carousel);

};

// Product productBigCarousel
function productBigCarousel(carousel,numberXl,numberLg,numberMd,numberSm,numberXs) {

    var windowW = window.innerWidth || $(window).width();

    var slidesToShowXl = (numberXl > 0) ? numberXl : 6;
    var slidesToShowLg = (numberLg > 0) ? numberLg : 4;
    var slidesToShowMd = (numberMd > 0) ? numberMd : numberLg;
    var slidesToShowSm = (numberSm > 0) ? numberSm : numberMd;
    var slidesToShowXs = (numberXs > 0) ? numberXs : 1;
    
    var carousel = carousel;
    var speed = 500;
        
    if (carousel.parent().find('.carousel-products__button').length > 0) {

            carousel.slick({
                    prevArrow: carousel.parent().find('.carousel-products__button .btn-prev'),
                    nextArrow: carousel.parent().find('.carousel-products__button .btn-next'),
                    dots: true,
                    slidesToShow: slidesToShowXl,
                    slidesToScroll: slidesToShowXl,
                    responsive: [{
                        breakpoint: 1770,
                        settings: {
                            slidesToShow: slidesToShowLg,
                            slidesToScroll: slidesToShowXs
                        }
                    },{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: slidesToShowMd,
                            slidesToScroll: slidesToShowXs
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: slidesToShowSm,
                            slidesToScroll: slidesToShowXs
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: slidesToShowXs,
                            slidesToScroll: slidesToShowXs
                        }
                    }]
                });
        }
        else {
            carousel.slick({
                slidesToShow: slidesToShowXl,
                slidesToScroll: 1,
                speed: speed,
                    responsive: [{
                        breakpoint: 1770,
                        settings: {
                            slidesToShow: slidesToShowLg,
                            slidesToScroll: slidesToShowXs
                        }
                    },{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: slidesToShowMd,
                            slidesToScroll: slidesToShowXs
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: slidesToShowSm,
                            slidesToScroll: slidesToShowXs
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: slidesToShowXs,
                            slidesToScroll: slidesToShowXs
                        }
                    }]
            });
        }
    

    fixCarouselHover(carousel);

};

// Carousel Product Mobile only	
function mobileOnlyCarousel() {

    var windowW = window.innerWidth || $(window).width();

    var carouselMobileOnly = $('.carousel-products-mobile');
    
    if (windowW < 480) {
        $('.carousel-products-mobile').slick({
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }
    $(window).resize(debouncer(function(e) {
    
        var currentW = window.innerWidth || $(window).width();
        
        if (currentW < 480) {
          if(carouselMobileOnly && carouselMobileOnly.length) {
            carouselMobileOnly.slick({
              slidesToShow: 1,
              slidesToScroll: 1
            });
          }
        } else {
            if (carouselMobileOnly.hasClass('slick-initialized')){
                carouselMobileOnly.slick('unslick');
            }
        }
    }))
};

// Product thumbnails carousel
function thumbnailsCarousel(carousel) {
    carousel.slick({
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },{
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }]
    });
}

// Fix z-index problem on carousel hover
function fixCarouselHover(carousel) {
    carousel.find('.slick-slide').bind( "mouseenter mouseleave",
            function( event ){
                $(this).closest('.slick-slider').toggleClass('hover');
            }
    );			
};

// Set Product Size 
function setProductSize() {
    
    var windowW = window.innerWidth || $(window).width();
    
    if (windowW > 767) {
        $('.product').each(function() {
            var productH = $(this).outerHeight();
            $(this).css({
                'min-height': productH + 'px'
            });
            $(this).find('.product__inside').addClass('pos-abs');
        });
    }

    $(window).resize(function(e) {
        $('.product').each(function() {
            $(this).css({
                'min-height': ''
            })
            $(this).find('.product__inside__info').css({
                'height': '0'
            })
            $(this).find('.product__inside').removeClass('pos-abs');
        })
        
        var timeout;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            var currentW = window.innerWidth || $(window).width();
            $('.product').each(function() {
                $(this).find('.product__inside__info').css({
                    'height': ''
                });
                if (currentW > 767) {
                    var productH = $(this).outerHeight();
                    $(this).css({
                        'min-height': productH + 'px'
                    });
                    $(this).find('.product__inside').addClass('pos-abs');
                }
            });
        }, 1000);				
    })
};

// menu click go URL
function navbarClick() {
    var windowW = window.innerWidth || $(window).width();
  
    // mobile menu off width
    if (windowW > 1025) {
        $('.navbar .dropdown > a').on('click', function(){
            location.href = this.href;
            return false
        });
    }
};

// Set Product Page Prev-Next Arrows Position at center of the product image 
function setProductArrows() {
    var windowW = window.innerWidth || $(window).width();
    var setArrowPos = function(windowW) {
        if (windowW > 1199) {
            var imgH = $('.product-main-image img').height();
            $('#productPrevNext > a').css({'top': imgH/2 + 'px'});
        }
    }
    setArrowPos(windowW);
    $(window).resize(debouncer(function(e) {
        var currentW = window.innerWidth || $(window).width();
        setArrowPos(currentW);
    }))
};
	
// Set Mobile Carousel Arrows Position at center of the product image
function setCarouselArrows() {
    var windowW = window.innerWidth || $(window).width();
    var setArrowPos = function(windowW) {
        if (windowW < 480) {
            if ($('.carousel-products-mobile.slick-initialized').length || $('.carousel-products.slick-initialized').length){
                $('.carousel-products-mobile').each(function() {
                    var imgH = $(this).find('.slick-list .slick-track .slick-slide:first-child img').height();
                    $(this).find('.slick-arrow').css({'top': imgH/2 + 'px'});
                })					
                $('.carousel-products').each(function() {
                    if ($(this).parent().parent().find('.carousel-products__button').length > 0) {
                        var imgH = $(this).find('.slick-list .slick-track .slick-slide:first-child img').height();
                        var titleH = $(this).parent().parent().find('.title-with-button').height();
                        $(this).parent().parent().find('.carousel-products__button').css({'top': imgH/2 + titleH + 'px'});
                    }
                })
            }
        } else {
            $('.carousel-products').each(function() {
                if ($(this).parent().parent().find('.carousel-products__button').length > 0) {
                    $(this).parent().parent().find('.carousel-products__button').css({'top': ''});
                }
                else {
                    var imgH = $(this).find('.slick-list .slick-track .slick-slide:first-child img').height();
                    $(this).find('.slick-arrow').css({'top': imgH/2 + 'px'});
                }
            })
        }		
    }
    setArrowPos(windowW);
    $(window).resize(debouncer(function(e) {
        var currentW = window.innerWidth || $(window).width();
        setArrowPos(currentW);
    }))
};

// Set mobile dropdowns width
function setMobileDrop() {
    var windowW = $('body').innerWidth();
    var setDropsW;
  
    setDropsW = function(windowW) {
    // mobile menu off width
        if (windowW < 1025) {
            $('.dropdown-menu--xs-full').each(function() {
                $(this).css({'width': windowW + 'px'});
            })			
        }
        else {
            $('.dropdown-menu--xs-full').each(function() {
                $(this).css({'width': ''});
            })	
        }
    }      
    setDropsW(windowW);
    $(window).resize(debouncer(function(e) {
        var currentW = $('body').innerWidth();
        setDropsW(currentW);
    })) 
};
	
// DropDown Close
function handlerDropDownClose() {
    $('.dropdown-menu__close').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.dropdown.open .dropdown-toggle').dropdown('toggle');
    });   
};
	
// Mobile footer collapse
function footerCollapse() {
    $('.mobile-collapse__title').on('click', function(e) {
        e.preventDefault;
        $(this).parent('.mobile-collapse').toggleClass('open');
    })
};
	
$(window).bind('reinitSliderInProduct', productInsideCarousel);

// Product inside carousel
function productInsideCarousel() {
  $(".product__inside__carousel").each(function () {
    var $this = $(this);
    if(!$this.hasClass('isInit')) {
      $this.addClass('isInit');
      $this.carousel({
        interval: false
      })
      $this.find('.carousel-control.next').on('click', function() {
        $this.carousel('next');
      });		
      $this.find('.carousel-control.prev').on('click', function() {
        $this.carousel('prev');
      });
    }
  });
};
	
// Category list collapse
function expanderList() {
    $('.expander-list .expander').each(function() {
        if ($(this).parent('li').hasClass('active')){
            $(this).next('ul').slideDown(0);
            $(this).parent().addClass('open');
        }
    })
    $(".expander-list .expander").on('click', function(e) {
        e.preventDefault;
        var speed = 300;
        var thisItem = $(this).parent(),
            nextLevel = $(this).next('ul');
        if (thisItem.hasClass('open')){
            thisItem.removeClass('open');
            nextLevel.slideUp(speed);
        }
        else {
            thisItem.addClass('open');
            nextLevel.slideDown(speed);
        }
    })
};
	
// Collapse Block (left column in listing)
function collapseBlock() {
    $('.collapse-block__content').each(function() {
        if ($(this).parent('.collapse-block').hasClass('open')){
            $(this).slideDown(0);
        }
    })
    $('.collapse-block__title').on('click', function(e) {
        e.preventDefault;
        var speed = 300;
        var thisItem = $(this).parent(),
            nextLevel = $(this).next('.collapse-block__content');
        if (thisItem.hasClass('open')){
            thisItem.removeClass('open');
            nextLevel.slideUp(speed);
        }
        else {
            thisItem.addClass('open');
            nextLevel.slideDown(speed);
        }
    })
};
	
// Listing view mode
function listingModeToggle() {		
    $('a.link-row-view').on('click', function(e) {
        e.preventDefault();
        $(this).addClass('active');
        $('a.link-grid-view').removeClass('active');
        $('.product-listing').addClass('row-view');
    })
    $('a.link-grid-view').on('click', function(e) {
        e.preventDefault();
        $(this).addClass('active');
        $('a.link-row-view').removeClass('active');
        $('.product-listing').removeClass('row-view');
    })
}

// Blog carousel
function blogPostSlider(){
	"use strict";
    if ($(".blogPostSlider").length > 0) {
        $('.blogPostSlider').slick({
		  infinite: true,
		  slidesToShow: 1
		});
    }	
}

// Tabs
function initTabsGallery(){
  $('.nav-tabs--ys-center a').each(function(){
    $(this).click(function(){
      $(this).unbind();
      var tab = $(this).attr("href");
      var clone = tab+"-clone";
      $(tab).empty();
      $(clone).children().clone().appendTo($(tab));
      var $obj = $(tab).find(".carouselTab");
      $obj.css("visibility", "hidden");
      if($obj.length) {
        setTimeout(function(){
          productCarousel($obj,6,4,3,2,1);
          $obj.hide();
          $obj.css("visibility", "visible");
          $obj.fadeIn(500);
        }, 5);
      }
    })
  });
}

// slider on product-fields
function sliderNoZoom(){
  if ($(".slider-no-zoom").length > 0) {
    $('.slider-product-large').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      infinite: true,
      waitForAnimate: false
    });

    function updateThumbnailClass(index) {
        $('#sliderNav img').each(function() {
            $(this).removeClass("border-color-primary");
        });

        $('#sliderNav').children().eq(index).addClass("border-color-primary");
    }

    $('.slider-product-large').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        updateThumbnailClass(nextSlide);
    });

    $('#sliderNav').on( "click", "img", function() {
        var index = $(this).data('index');

        $('.slider-product-large').slick("slickGoTo", index);
        updateThumbnailClass(index);
    });
  }	
  if ($(".slider-no-zoom-no-controls").length > 0) {
    $('.slider-product-large-no-controls').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      centerPadding: '40px',
      infinite: true
    });
  }	
}

// Elevate Zoom
function elevateZoom() {

var windowW = window.innerWidth || document.documentElement.clientWidth;
$('.product-zoom').imagesLoaded(function() {
if ($('.product-zoom').length) {

    var zoomPosition
  if ( $('html').css('direction').toLowerCase() == 'rtl' ) {
   zoomPosition = 11;
  }
  else {
   zoomPosition = 1
  }


 if (windowW > 767) {
  $('.product-zoom').elevateZoom({
   //zoomWindowHeight: $('.product-zoom').height(), // if zoom container must be as image height
   zoomWindowWidth: $('.product-zoom').width()- 60,
   zoomWindowHeight: $('.product-zoom').width() - 60,
   gallery: "smallGallery",
   galleryActiveClass: 'active',
   zoomWindowPosition : zoomPosition
  })
 } else {
  $(".product-zoom").elevateZoom({
   gallery: "smallGallery",
   zoomType: "inner",
   galleryActiveClass: 'active',
   zoomWindowPosition : zoomPosition
  });
 }
}
})


$('.product-main-image > .product-main-image__zoom ').bind('click', function(){
  galleryObj = [];
  current = 0;
  itemN = 0;
  
 if ($('#smallGallery').length){
  console.log('1');
  $('#smallGallery li a').not('.video-link').each(function() {
   if ($(this).hasClass('active')) {
    current = itemN;
   }
   itemN++;
   var src = $(this).data('zoom-image'),
    type = 'image';
    image = {};
    image ["src"] = src;
    image ["type"] = type;

   galleryObj.push(image);
  });
 }
 
 else {
  console.log('2');
   itemN++;
   var src = $(this).parent().find('.product-zoom').data('zoom-image'),
    type = 'image';
    image = {};
    image ["src"] = src;
    image ["type"] = type;

   galleryObj.push(image);
 }

 $.magnificPopup.open({
  items: galleryObj,
  gallery: {
   enabled: true,
  }
 }, current);
 
});

var  prevW = windowW;


$(window).resize(debouncer(function(e) {
 var currentW = window.innerWidth || $(window).width();
  
 if (currentW != prevW) {
  // start resize events
  $('.zoomContainer').remove();
  $('.elevatezoom').removeData('elevateZoom');
  if ($('.product-zoom').length) {
   if (currentW > 767) {
    $('.product-zoom').elevateZoom({
     zoomWindowHeight: $('.product-zoom').height(),
     gallery: "smallGallery"
    })
   } else {
    $(".product-zoom").elevateZoom({
     gallery: "smallGallery",
     zoomType: "inner"
    });
   }
  }
  // end resize events  
 }
 prevW = window.innerWidth || $(window).width();
}));
}

// Elevate Zoom 1
function elevateZoom1() {
  var currentW = window.innerWidth || $(window).width();
  if (currentW > 767) {
      if ($('.product-zoom1').length) {
           $('.product-zoom1').elevateZoom({
              zoomType: "inner",
              cursor: "crosshair",
              zoomWindowFadeIn: 300,
              zoomWindowFadeOut: 300
          }); 
      }
  }
}

$(function() {	
  "use strict";
  
  // Remove Loader
  $('body').addClass('loaded');

  navbarClick();
  setMobileDrop();
  handlerDropDownClose();
  footerCollapse();
  productInsideCarousel();
  expanderList();
  collapseBlock();
  slideColumn();
  blogPostSlider();

  var newSelection = "";

  $(".filter-nav a").click(function(){
    $("#all-filter-content").hide(0);
    $("#all-filter-content").fadeIn(500);
    $(".filter-nav a").removeClass("current");
    $(this).addClass("current");
    
    newSelection = $(this).attr("rel");
    
    $(".filter-content-item").not("."+newSelection).fadeOut();
    $("."+newSelection).fadeIn();
    $("#all-filter-content").fadeIn(0);
  });
  
  if($('[data-toggle="tooltip"]').length) {
    $('[data-toggle="tooltip"]').tooltip()
  }

  if($(".toggle-menu").length) {
    $(".toggle-menu .icon, .toggle-menu .close").click(function() {
        $(".toggle-menu .dropdown-menu").fadeToggle();
    });
  }

  // Mobile Menu 
  if ($("#off-canvas-menu").length > 0) {
    "use strict";
    $(document).bind('cbox_open', function() {
      $('body').css("top", -$('body').scrollTop());
      $('body').addClass("no-scroll");
    }).bind('cbox_closed', function() {
      var top = parseInt($('body').css("top").replace("px", ""))*-1;
      $('body').removeAttr("style");
      $('body').removeClass("no-scroll");
      $('body').scrollTop(top);
    });

    // check if RTL mode
    var colorBoxMenuPosL = ($("body").hasClass('rtl')) ? 'none' : '0';
    var colorBoxMenuPosR = ($("body").hasClass('rtl')) ? '0' : 'none';

    $("#off-canvas-menu-toggle").colorbox({
      inline: true,
      opacity: 0.55,
      transition: "none",
      arrowKey: false,
      width: "300",
      height: "100%",
      fixed: true,
      className: 'canvas-menu',
      top: 0,
      right: colorBoxMenuPosR,
      left: colorBoxMenuPosL,
      colorBoxCartPos: 0
    });
  }

  $("#off-canvas-menu .expander-list").find("ul").hide().end().find(" .expander").text("+").end().find(".active").each(function() {
    $(this).parents("li ").each(function() {
      var $this = $(this),
          $ul = $this.find("> ul"),

          $expander = $this.find("> .name .expander");
      $ul.show();

      $expander.html("&minus;")
    })
  }).end().find(" .expander").each(function() {
    var $this = $(this),
        hide = $this.text() === "+",
        $ul = $this.parent(".name").next("ul"),
        $name = $this.next("a");
    $this.click(function() {
      if ($ul.css("display") ==
          "block") $ul.slideUp("slow");
      else $ul.slideDown("slow");
      $(this).html(hide ? "&minus;" : "+");	            
      hide = !hide
    })
  });
  // end mobile

  // Tabs
  if($('.nav-tabs--ys-center').length) {
    initTabsGallery();
  
    $('.nav-tabs--ys-center .active a').trigger('click');
    $(window).resize(function(){
      $('.nav-tabs--ys-center a').unbind();
      initTabsGallery();
    });
  
  }
});
